module.exports = __webpack_public_path__ + "assets/img/comment.6d918ac0.svg";